import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ROUTES } from 'config/routes';
import LoadingSkeleton from 'components/feedback/LoadingSkeleton';
import {
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  ActivateAccountPage,
  B2bAccessRequestPage,
} from 'pages';

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSkeleton rows={3} />}>{children}</Suspense>
);

export const guestRoutes = (
  <>
    <Route path={ROUTES.LOGIN} element={<Lazy><LoginPage /></Lazy>} />
    <Route path={ROUTES.REGISTER} element={<Lazy><RegisterPage /></Lazy>} />
    <Route path={ROUTES.FORGOT_PASSWORD} element={<Lazy><ForgotPasswordPage /></Lazy>} />
    <Route path={ROUTES.ACTIVATE_ACCOUNT} element={<Lazy><ActivateAccountPage /></Lazy>} />
    <Route path={ROUTES.B2B_ACCESS_REQUEST} element={<Lazy><B2bAccessRequestPage /></Lazy>} />
  </>
);
